import Currencies from './components/Currencies';

export default Currencies;
